import type { Asset } from "contentful";
import { Text } from "@ui/components/content/text/Text";
import { Box } from "@ui/components/layout/box/Box";
import { GridItem } from "@ui/components/layout/grid/Grid";
import { NextImage } from "@ui/components/media-and-icons/image/NextImage";
import React from "react";
import { EditorialWidgetStyles } from "./ProductListStyles";
import { Link } from "@components/cms/link/Link";
import type { IPagePath, ILink } from "@contentful-api/types/contentful";
import { space } from "@ui/design-tokens";

interface IProps {
    key: number;
    image: Asset;
    title?: string;
    styles: {
        colSpan?: number | number[];
        rowStart?: number | number[];
        colStart?: number | number[];
        fontSize?: string | string[];
    };
    link?: IPagePath | ILink;
    widgetSize: string;
    isVisible?: boolean;
}

export const EditorialWidget = ({
    key,
    image,
    title,
    styles,
    widgetSize,
    link,
    isVisible,
}: IProps) => {
    const mapWidgetSizeToImageSize = (widgetSize: string) => {
        const sizeMap = {
            Small: "100vw",
            Tall: "80vw",
            Big: "100vw",
        };
        return sizeMap[widgetSize] ?? "100vw";
    };

    return (
        // If styles prop exists, means that the widget computation was valid.
        styles && (
            <GridItem
                position={"relative"}
                // Height of the grid + the row gap
                height={["575px", `calc(100% + ${space[12]})`, `calc(100% + ${space[12]})`]}
                //We use display to avoid a re-load of the image when the widget is not visible
                display={isVisible ? "flex" : "none"}
                {...styles}
            >
                <NextImage
                    src={image.fields.file.url}
                    objectFit="cover"
                    display="flex"
                    sizes={["200vw", "200vw", mapWidgetSizeToImageSize(widgetSize)]}
                    alt={image?.fields?.title}
                    key={key}
                    fill={true}
                />
                {link ? (
                    <Link link={link}>
                        <Box
                            sx={{
                                ...EditorialWidgetStyles,
                                ...(title ? { backgroundColor: "rgba(0, 0, 0, 0.28)" } : {}),
                            }}
                        >
                            <Text color="white" fontSize={styles?.fontSize} fontWeight="bold">
                                {title}
                            </Text>
                        </Box>
                    </Link>
                ) : (
                    <Box
                        sx={{
                            ...EditorialWidgetStyles,
                            ...(title ? { backgroundColor: "rgba(0, 0, 0, 0.28)" } : {}),
                        }}
                    >
                        <Text color="white" fontSize={styles?.fontSize} fontWeight="bold">
                            {title}
                        </Text>
                    </Box>
                )}
            </GridItem>
        )
    );
};
